import type { AppState } from '../../store/types';

// appReducer.host should be empty in the web so if this is the case
// use location.host. The panel will have a custom host set based on what system it runs
// against.
export const getHost = (state: AppState) => {
  const host =
    state.appReducer.host.length > 0
      ? state.appReducer.host
      : window.location.host;
  return host;
};

export const getProtocol = () =>
  window.location.protocol.startsWith('http')
    ? window.location.protocol
    : 'https:';

export const getBaseUrl = (state: AppState) =>
  `${getProtocol()}//${getHost(state)}`;
